module.exports = __webpack_public_path__ + "img/item1-8m.59e50945.jpg";